import React from 'react';
import { TickMarkIcon } from '../icons/TickMarkIcon.jsx';
import TranslationText from "./Translation/TranslationText.jsx";

export function AuthenticationFeatureStatusBadge({ isAdded, translationKey }) {
  return (
    <span className={`auth-feature-status-badge ${isAdded ? 'added' : 'not-added'}`}>
      <span className="auth-feature-status-badge-content">
        <TranslationText text={translationKey || (isAdded ? 'auth_feature_added_status_badge_label' : 'auth_feature_not_added_status_badge_label')} />
        {isAdded && <TickMarkIcon />}
      </span>
    </span>
  );
}